<template>
  <div>
    <Alert closable
      >股权集中度为持股比例前几经纪商的持股比例加总，一定程度反映主力机构投资者对后市的股价态度。</Alert
    >
    <div class="s-box">
      <div id="s-box">
        <form @submit.stop="reRender(code)" onSubmit="return false">
          <Input v-model="code" search placeholder="输入股票代码" />
        </form>
      </div>
    </div>
    <h2>
      <menu-title></menu-title>
    </h2>
    <h3 style="margin:0 auto;text-align:center">
      {{ title }}
      ({{ code }}) 股权集中度
    </h3>

    <div class="class-box">
      <div id="chart-2" :style="{ width: '100%', height: '400px' }"></div>
    </div>
  </div>
</template>
<script>
import menuTitle from "../components/menu-title";
import dayjs from "dayjs";
export default {
  components: {
    menuTitle,
  },
  data() {
    return {
      code: "",
      dom: "",
      title: "",
      list: [],
      showChart: false,
      echartOpt: {
        name: "holding",
        backgroundColor: "",
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            crossStyle: {
              color: "#999",
            },
          },
        },
        toolbox: {
          feature: {
            dataView: {
              show: true,
              readOnly: false,
            },
            magicType: {
              show: true,
              type: ["line", "bar"],
            },
            restore: {
              show: true,
            },
            saveAsImage: {
              show: true,
              name: `股权集中度`,
            },
          },
        },
        color: ["#3398DB"],
        legend: {
          data: ["top5", "top10", "top10 + not in ccass", "股价"],
        },
        xAxis: {
          type: "category",
          data: [],
        },
        yAxis: [
          {
            type: "value",
            name: "holding",
            default: "center",
            offset: 0,
            min: function(value) {
              return value.min - 13;
            },
            data: [100, 1000],
            axisLabel: {
              formatter: "{value} %",
            },
          },
          {
            type: "value",
          },
        ],
        dataZoom: [
          {
            type: "inside",

            start: 60,
            end: 100,
          },
          {
            start: 0,
            end: 10,
            handleIcon:
              "M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z",
            handleSize: "80%",
            handleStyle: {
              color: "#fff",
              shadowBlur: 3,
              shadowColor: "rgba(0, 0, 0, 0.6)",
              shadowOffsetX: 2,
              shadowOffsetY: 2,
            },
          },
        ],
        series: [
          {
            color: "#f8740b",
            name: "股价",
            type: "line",
            yAxisIndex: 1,
            data: [],
          },
          {
            color: "#f11660",
            data: [],
            name: "top5",
            type: "line",
          },
          {
            name: "top10",
            type: "line",
            data: [],
          },
          {
            color: "green",
            name: "top10 + not in ccass",
            type: "line",
            data: [],
          },
        ],
      },
    };
  },
  methods: {
    async fetchData(stockCode) {
      const { data } = await this.$api.GetCassStockBrokerProfile({
        stockCode,
      });
      if (data) {
        this.showChart = true;
      }
      if (!data || (data && !data.concentration)) {
        this.$Message.info({
          content: "当前股票代码无数据",
        });
        this.title = "无数据";
        this.concentration = [];
        this.echartOpt.xAxis.data = [];
        this.echartOpt.series[0].data = [];
        this.echartOpt.series[1].data = [];
        this.echartOpt.series[2].data = [];
        this.echartOpt.series[3].data = [];
        return false;
      }
      this.title = data.name;
      data.concentration = data.concentration.sort(
        (a, b) => a.tradingDay - b.tradingDay
      );
      this.echartOpt.xAxis.data = data.concentration.map((i) =>
        dayjs.unix(i.tradingDay).format("YYYY-MM-DD")
      );
      this.echartOpt.series[0].data = data.concentration.map((i) => i.price);
      this.echartOpt.series[1].data = data.concentration.map((i) => i.top5);
      this.echartOpt.series[2].data = data.concentration.map((i) => i.top10);
      this.echartOpt.series[3].data = data.concentration.map(
        (i) => i.notInCcassTop10
      );
      return true;
    },
    initOpions() {
      this.dom = document.getElementById("chart-2");
      const chats = echarts.init(this.dom);
      chats.setOption(this.echartOpt);
    },
    async reRender(code) {
      if (!code) {
        return;
      }
      await this.fetchData(code);
      this.dom = document.getElementById("chart-2");
      const chats = echarts.init(this.dom);
      chats.setOption(this.echartOpt);
      this.$router.push(`/concentration/${code}`);
    },
  },
  async mounted() {
    const stockCode = this.$route.params.code;
    this.code = stockCode;
    await this.fetchData(stockCode);
    this.initOpions();
  },
  beforeDestroy() {
    echarts.dispose(this.dom);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
  margin: 20px;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.s-box {
  position: absolute;
  width: 400px;
  left: 50%;
  margin-left: -200px;
  top: 13px;
  z-index: 2000;
}

#s-box {
  width: 100%;
  max-width: 360px;
  position: absolute;
  left: 50%;
  margin-left: -180px;
  z-index: 1;
}
</style>
